// extracted by mini-css-extract-plugin
export default {"infoFullBox":"InfoTextBox_infoFullBox__6GQME","smInnerBox":"InfoTextBox_smInnerBox__+802x"};